<cft-contact-bottom-navigation *transloco="let t" [benefits]="(benefits$ | async)!" [showGuarantee]="!!guaranteeText">
  <cft-call-to-action
    content="mainCta"
    callToActionStyle="button-sm"
    buttonStyle="hero"
    data-testid="main-cta"
    [callToAction]="getCallToAction()"
  />

  @if (guaranteeText) {
    <div content="guaranteeText">{{ t('profile.guaranteeText') }}</div>
  }
</cft-contact-bottom-navigation>
